const removeNonDigitCharacters = (phoneNumber) => {
  const removeNonDigitsRegex = /[^\d]/g;
  const cleanPhoneNumber = phoneNumber.replace(removeNonDigitsRegex, '');

  return cleanPhoneNumber;
};

export default removeNonDigitCharacters;